<template>
  <div class="soortLayerSwitcherContainer">
    <ul class="panel" style="height: auto;">
      <li class="ol-header"></li>

      <li
        @click="changeVisibilityIfPossible(lc)"
        v-for="lc in layerconfig"
        :key="lc.name"
        class="soort border-primary p-1"
        :class="{'ol-visible':lc.visible,'d-none':!lc.visible && !lc.userSelectable}"
      >
        <i
          v-show="lc.visible"
          style="font-size:1rem"
          class="text-primary fa fa-check-circle"
          aria-hidden="true"
        ></i>

        <span class="d-none d-lg-inline-block">{{lc.label}}</span>
        <span class="d-sm-block d-md-inline-block d-lg-none">{{lc.name}}</span>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { HIDE_LEGEND, UPDATE_VISIBILITY } from "../store/mutation-types";
import { UPDATE_LAYER_VISIBILITY } from "../store/action-types";
import {
  GET_LAYERCONFIG,
  GET_CONFIG,
  GET_LEGEND_SHOW,
} from "../store/getters-types";

export default {
  methods: {
    ...mapActions({
      updateLayer: UPDATE_LAYER_VISIBILITY,
    }),
    ...mapMutations({
      hideLegend: HIDE_LEGEND,
    }),
    changeVisibilityIfPossible(layerConfigItem) {
      if (layerConfigItem.userSelectable) {
        this.updateLayer({
          name: layerConfigItem.name,
          visible: !layerConfigItem.visible,
        });
        //layerConfigItem.visible = !layerConfigItem.visible;
      }
    },
  },
  computed: {
    layerconfig() {
      return this.$store.state.config.layerconfig;
    },
  },
};
</script>
<style lang="scss" scoped>
.soortLayerSwitcherContainer {
  position: absolute;
  z-index: 2000;
  left: 5rem;
  .panel {
    list-style: none;
    padding: 0.25em;
    margin: 0;
    overflow: hidden;

    .soort {
      &.ol-visible {
        border-width: 3px;
      }
      border-radius: 4px;
      border: 1px solid transparent;
      -webkit-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
      box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
      display: inline-block;

      //height: 30px;
      margin: 2px;
      position: relative;

      background-color: #fff;
      overflow: hidden;
      vertical-align: middle;
      cursor: pointer;
    }
  }
}
</style>